var map = {
	"./cam-plus-photos.svg": "10ef",
	"./game-controller.svg": "6326",
	"./icons8-back-50.png": "1fe0",
	"./left-arrow.png": "2a0b",
	"./logo.png": "cf05",
	"./mario.jpg": "d0a7",
	"./microphone.svg": "4087",
	"./software-dev.svg": "2330",
	"./z-gruen-dunkel.svg": "f92c",
	"./z.svg": "a1f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";